<section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
        <mat-icon>close</mat-icon>
    </button>
    <h3>Delete your account</h3>
</section>
<section mat-dialog-content>
    <p>
        Are you sure you want to delete your account? This action cannot be undone.
    </p>
    <p class="alert-box warning">
        Deleting your account will remove all your data. You will no longer have access to the offers on the
        Partner Choice platform.
    </p>
</section>
<section align="end" mat-dialog-actions>
    <button mat-button mat-dialog-close matTooltip="Cancel and close." type="button">
        <mat-icon>cancel</mat-icon>
        Cancel
    </button>
    <button mat-button matTooltip="Confirm account deletion." (click)="deleteAccountConfirm()" type="button">
        <mat-icon>delete</mat-icon>
        Confirm
    </button>
</section>